import { render, staticRenderFns } from "./LogosList.vue?vue&type=template&id=2c5d8f9d&scoped=true&"
import script from "./LogosList.vue?vue&type=script&lang=js&"
export * from "./LogosList.vue?vue&type=script&lang=js&"
import style0 from "./LogosList.vue?vue&type=style&index=0&id=2c5d8f9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d8f9d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/LogosList.vue
// module id = 214
// module chunks = 0